import { AppBarSection } from "@progress/kendo-react-layout";
import { updateIframeSrc } from "../../slices/RevelationSlice";
import { useReduxDispatch } from "../../redux/hooks";
// import testImage from "./images/Host_Images/Login/revelationLogo_login_Syn.gif"

/** For testing purposes only.
 * In order to manually test styles by manually changing numbers the
 * following must occur:
 * 1. export the navStyle below.
 * 2. Uncomment the SetLogoNavStyle(navStyle) and comment out the one with props.navStyleNavButton.tsx
 * 3. In NavButton.tsx, uncomment out the navStyle import.
 * 4. In NavButton.tsx, comment out navStyle.*/
// export let navStyle = 0;

export type NavLogoProps = {
  imgUrl: string;
  navStyle?: number;
};
const NavLogo = ({ props }: { props: NavLogoProps }) => {
  // Left here for testing purposes
  // const maxHeight = SetLogoNavStyle(navStyle);
  const maxHeight = SetLogoNavStyle(props.navStyle);
  const imgClass = "w-auto " + maxHeight;
  const dispatch = useReduxDispatch();
  return (

    <AppBarSection
      style={{
        // width: 128,
        display: "grid",
        justifyContent: "center",
      }}
    >
      <div className="flex justify-center">
        <a href="#" title="Home" onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          e.nativeEvent.stopImmediatePropagation()
          e.nativeEvent.preventDefault()

          dispatch(updateIframeSrc("/Calls/OpenCalls.aspx"))
        }
        }>
          <img
            className={imgClass} src={`${props.imgUrl}`} alt="Site logo"
          /></a>
      </div>
    </AppBarSection>
  );
};
export default NavLogo;

function SetLogoNavStyle(navStyle: number): string {
  const normalSize = "h-[70px]";
  const halfSize = "h-[43px]";
  switch (navStyle) {
    case 1:
      return normalSize;
    case 2:
      return halfSize;
    case 3:
      return halfSize;
    default:
      return normalSize;
  }
}
